const normalizeSummaryList = (items = []) => (
  Array.from(new Set((Array.isArray(items) ? items : [])
    .map((item) => String(item || '').trim())
    .filter(Boolean)))
);

export const formatVideoconsultationSummaryLabel = (value) => (
  String(value || '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (character) => character.toUpperCase())
);

export const normalizeVideoconsultationSummary = (summary) => {
  if (!summary || typeof summary !== 'object') {
    return null;
  }

  const normalized = {
    diagnosisIdentifier: String(summary.diagnosis_identifier || summary.diagnosisIdentifier || '').trim(),
    reportedSpecialities: normalizeSummaryList(summary.reported_specialities || summary.reportedSpecialities),
    reportedSymptomTags: normalizeSummaryList(summary.reported_symptom_tags || summary.reportedSymptomTags),
    redFlagTags: normalizeSummaryList(summary.red_flag_tags || summary.redFlagTags),
    defaultRecommended: Boolean(
      summary.default_recommended !== undefined
        ? summary.default_recommended
        : summary.defaultRecommended
    ),
  };

  const hasContent = normalized.diagnosisIdentifier
    || normalized.reportedSpecialities.length > 0
    || normalized.reportedSymptomTags.length > 0
    || normalized.redFlagTags.length > 0;

  return hasContent ? normalized : null;
};

export const appendVideoconsultationSummaryToParams = (params, summary) => {
  const normalized = normalizeVideoconsultationSummary(summary);
  if (!params || !normalized) {
    return params;
  }

  params.set('vc_recommended', normalized.defaultRecommended ? 'true' : 'false');

  if (normalized.diagnosisIdentifier) {
    params.set('vc_diagnosis', normalized.diagnosisIdentifier);
  }
  if (normalized.reportedSpecialities.length > 0) {
    params.set('vc_specialities', normalized.reportedSpecialities.join(','));
  }
  if (normalized.reportedSymptomTags.length > 0) {
    params.set('vc_symptoms', normalized.reportedSymptomTags.join(','));
  }
  if (normalized.redFlagTags.length > 0) {
    params.set('vc_red_flags', normalized.redFlagTags.join(','));
  }

  return params;
};

export const readVideoconsultationSummaryFromQuery = (query) => {
  const params = query instanceof URLSearchParams ? query : new URLSearchParams(query || '');
  return normalizeVideoconsultationSummary({
    default_recommended: params.get('vc_recommended') === 'true',
    diagnosis_identifier: params.get('vc_diagnosis') || '',
    reported_specialities: (params.get('vc_specialities') || '').split(','),
    reported_symptom_tags: (params.get('vc_symptoms') || '').split(','),
    red_flag_tags: (params.get('vc_red_flags') || '').split(','),
  });
};

export const buildVideoconsultationRecommendationCopy = (summary) => {
  const normalized = normalizeVideoconsultationSummary(summary);
  if (!normalized) {
    return null;
  }

  if (normalized.defaultRecommended) {
    return {
      title: 'Videoconsultation looks suitable',
      body: 'Based on the intake answers so far, a videoconsultation appears suitable. The clinic can still review the details before confirming the best next step.',
      accent: '#2e7d5b',
      background: '#edf8f2',
      border: '#c7e6d3',
    };
  }

  return {
    title: 'An in-person review may be better',
    body: normalized.redFlagTags.length > 0
      ? 'The intake included signals the clinic may want to review in person first. You can still continue to see options and let the clinic make the final call.'
      : 'The intake suggests a videoconsultation may be less suitable. You can still continue and let the clinic decide on the best format.',
    accent: '#9a5b13',
    background: '#fff4e6',
    border: '#f2d2ad',
  };
};